const Solidity = () => (


 

/* <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Solidity</title><path d="M4.409 6.608L7.981.255l3.572 6.353H4.409zM8.411 0l3.569 6.348L15.552 0H8.411zm4.036 17.392l3.572 6.354 3.575-6.354h-7.147zm-.608-10.284h-7.43l3.715 6.605 3.715-6.605zm.428-.25h7.428L15.982.255l-3.715 6.603zM15.589 24l-3.569-6.349L8.448 24h7.141zm-3.856-6.858H4.306l3.712 6.603 3.715-6.603zm.428-.25h7.433l-3.718-6.605-3.715 6.605z"/></svg> */

<svg xmlns="http://www.w3.org/2000/svg"  viewBox="10 0 48 48" width="96px" height="96px" baseProfile="basic"><polygon fill="#1c1c1c" points="25,15 18.5,4 12,15"/><polygon fill="#666" points="38,15 31.5,4 25,15"/><polygon fill="#383838" points="18.5,4 25,15 31.5,4"/><polygon fill="#383838" points="12,15 18.5,26 25,15"/><polygon fill="#1c1c1c" points="25,33 31.5,44 38,33"/><polygon fill="#666" points="12,33 18.5,44 25,33"/><polygon fill="#383838" points="31.5,44 25,33 18.5,44"/><polygon fill="#383838" points="38,33 31.5,22 25,33"/></svg>

);

export default Solidity;
